module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "rateassist-details-t"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "shadow clearfix"
  }, [_c('hr', {
    staticClass: "hr-text",
    attrs: {
      "data-content": "Notes"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label",
    attrs: {
      "for": "note-title"
    }
  }, [_vm._v("Title")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.note.title),
      expression: "note.title"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "note-title"
    },
    domProps: {
      "value": (_vm.note.title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.note, "title", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label",
    attrs: {
      "for": "note-text"
    }
  }, [_vm._v("Note text")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.note.noteText),
      expression: "note.noteText"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "note-text"
    },
    domProps: {
      "value": (_vm.note.noteText)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.note, "noteText", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12"
  }, [_c('hr'), _vm._v(" "), _c('div', {
    staticClass: "pull-right"
  }, [_c('div', {
    staticClass: "btn btn-success",
    on: {
      "click": _vm.save
    }
  }, [_vm._v("\n              " + _vm._s(_vm.saveOrUpdate) + "\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "btn btn-danger",
    on: {
      "click": _vm.doClear
    }
  }, [_vm._v("\n              Clear\n            ")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12"
  }, [_c('vue-table', {
    attrs: {
      "tableData": _vm.notes,
      "tableTitle": "Notes",
      "showEdit": true,
      "showDelete": true,
      "fields": [{
          header: 'Title',
          prop: 'title'
        },
        {
          header: 'Note',
          prop: 'noteText'
        }
      ]
    },
    on: {
      "table-edit-request": _vm.updateActive,
      "table-delete-request": _vm.doDelete
    }
  })], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4392e6f6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/modules/admin/components/Tariff/TariffNotes.vue
// module id = 2167
// module chunks = 1